import Scope from "@app/types/dashboard/Scope";

const getDashboardPath = (scope: Scope): string => {
  if (scope.teamId && scope.userId) {
    return `/dashboard/teams/${scope.teamId}/users/${scope.userId}`;
  }
  if (scope.teamId) {
    return `/dashboard/teams/${scope.teamId}`;
  }
  if (scope.userId) {
    return `/dashboard/users/${scope.userId}`;
  }
  return "/dashboard";
};

export default getDashboardPath;
